export const userList = {
    "responseCode": {
        "msg": "Saved Successfully!",
        "status": "Success",
        "code": 200,
        "length": 0
    },
    "responseList": [
        {
            "id": "254",
            "name": "Sachin Shah",
            "email": "sachin.shah@infomo.com",
            "contact": "9898987676",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2024-12-18 10:57:15",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "242",
            "name": "Rohit",
            "email": "rohit.pandey@infomo.com",
            "contact": "9528652262",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2024-07-24 05:58:28",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "484",
            "name": "Himanshu",
            "email": "himanshu.verma@infomo.com",
            "contact": "9876543211",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2024-09-05 07:45:00",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "228",
            "name": "sachin sharma",
            "email": "sachin@infomo.com",
            "contact": "9528652262",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2024-08-13 12:01:59",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "261",
            "name": "Satyam Jaiswal",
            "email": "satyam.jaiswal@infomo.com",
            "contact": "9528652262",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2024-07-24 05:58:28",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "283",
            "name": "Neeraj Kushwaha",
            "email": "neeraj@infomo.com",
            "contact": "",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2024-11-22 10:54:03",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "240",
            "name": "Karan",
            "email": "karanveer@infomo.com",
            "contact": "9528652262",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2024-09-17 06:45:11",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "258",
            "name": "Saurav Chamoli",
            "email": "saurav.chamoli@infomo.com",
            "contact": "",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2024-11-28 13:43:00",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "503",
            "name": "Apoorv Gusain",
            "email": "apoorv.gusain@infomo.com",
            "contact": "",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2025-01-27 11:48:59",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "504",
            "name": "Abhishek Rawat",
            "email": "abhishek.rawat@infomo.com",
            "contact": "9528652262",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2025-01-27 11:14:50",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        },
        {
            "id": "505",
            "name": "Ankur Singh Bisht",
            "email": "ankur.bisht@infomo.com",
            "contact": "9807654321",
            "isActive": 1,
            "isRecActive": 1,
            "modifiedOn": "2025-01-28 05:03:31",
            "isUserPrimary": false,
            "roleTenantList": [
                {
                    "roleId": 1300,
                    "roleName": "ATD_User_Role",
                    "tenantId": 1760,
                    "tenantName": "Demo Advertiser",
                    "isActive": 1,
                    "isRecActive": 1
                }
            ],
            "miscData": []
        }
    ]
}

export const seatsList = {
    "responseCode": {
        "msg": "All Third Party Seats Fetched",
        "status": "Success",
        "code": 3030
    },
    "response": [
        {
            "campaignSynced": 2,
            "advertiserMapped": 2,
            "campaignMapped": 2,
            "advertiserIds": [
                1760,
                1874
            ],
            "accountType": 0,
            "margin": 30,
            "advertiserId": 1760,
            "agencyMargin": 0,
            "id": 9,
            "accountId": "6767031589",
            "masterAccountId": "2725631",
            "currency": "INR",
            "platformId": 5,
            "displayName": "BVT",
            "isActive": 1,
            "isRecActive": 1,
            "cDate": "Jan 16, 2025 5:50:25 AM",
            "cUser": 189,
            "mDate": "Jan 18, 2025 6:19:59 AM",
            "mUser": 0,
            "defaultSeat": 0,
            "seatType": 0,
            "masterAccountName": "CMR INR",
            "fees": 30,
            "timeZone": "Asia/Hong_Kong",
            "accountName": "BVT",
            "loginFlow": 0
        },
        {
            "campaignSynced": 3,
            "advertiserMapped": 3,
            "campaignMapped": 7,
            "advertiserIds": [
                1760,
                1867,
                1874
            ],
            "accountType": 0,
            "margin": 30,
            "advertiserId": 1760,
            "agencyMargin": 0,
            "id": 55,
            "accountId": "2557039093",
            "masterAccountId": "2557039093",
            "currency": "INR",
            "platformId": 4,
            "displayName": "Test Account (QA)",
            "isActive": 1,
            "isRecActive": 1,
            "cDate": "Jan 19, 2025 8:31:01 AM",
            "cUser": 189,
            "mUser": 0,
            "defaultSeat": 1,
            "seatType": 0,
            "masterAccountName": "Test Account (QA)",
            "fees": 30,
            "timeZone": "Asia/Calcutta",
            "accountName": "Test Account (QA)",
            "loginFlow": 0
        },
        {
            "campaignSynced": 0,
            "advertiserMapped": 3,
            "campaignMapped": 1,
            "advertiserIds": [
                1760,
                1867,
                1874
            ],
            "pages": [
                {
                    "advertiserId": 1760,
                    "id": 3096,
                    "tapId": 56,
                    "pageId": "317803264739781",
                    "accountId": "735759678205531",
                    "pageName": "Beki - Test "
                },
                {
                    "advertiserId": 1760,
                    "id": 3097,
                    "tapId": 56,
                    "pageId": "285250477997915",
                    "accountId": "735759678205531",
                    "pageName": "Beki"
                },
                {
                    "advertiserId": 1760,
                    "id": 3098,
                    "tapId": 56,
                    "pageId": "198764363327145",
                    "accountId": "735759678205531",
                    "pageName": "ATD "
                }
            ],
            "accountType": 0,
            "margin": 30,
            "advertiserId": 1760,
            "agencyMargin": 0,
            "id": 56,
            "accountId": "735759678205531",
            "currency": "INR",
            "platformId": 3,
            "displayName": "Torcai Internal",
            "isActive": 1,
            "isRecActive": 1,
            "cDate": "Jan 19, 2025 8:43:25 AM",
            "cUser": 189,
            "mDate": "Jan 27, 2025 7:19:51 AM",
            "mUser": 0,
            "defaultSeat": 1,
            "seatType": 0,
            "fees": 30,
            "timeZone": "Asia/Kolkata",
            "accountName": "Torcai Internal",
            "loginFlow": 1
        },
        {
            "campaignSynced": 0,
            "advertiserMapped": 2,
            "campaignMapped": 0,
            "advertiserIds": [
                1760,
                1874
            ],
            "accountType": 0,
            "margin": 30,
            "advertiserId": 1760,
            "agencyMargin": 0,
            "id": 67,
            "accountId": "4774633019",
            "masterAccountId": "4774633019",
            "currency": "INR",
            "platformId": 4,
            "displayName": "testing google ads",
            "isActive": 1,
            "isRecActive": 1,
            "cDate": "Jan 22, 2025 12:01:26 PM",
            "cUser": 189,
            "mUser": 0,
            "defaultSeat": 0,
            "seatType": 0,
            "masterAccountName": "testing google ads",
            "fees": 30,
            "timeZone": "Asia/Calcutta",
            "accountName": "testing google ads",
            "loginFlow": 0
        }
    ],
    "length": 0
}